import { BusinessObjectBase } from './base';
import type { ProcessInstance } from './process-instance';

export interface PendingStateUpdateData {
  readonly id: string;
  readonly triggerId?: string;
  readonly timestamp?: Date;
  readonly processInstanceId: number;
  readonly processInstance?: ProcessInstance;
}

export interface PendingStateUpdate extends Readonly<PendingStateUpdateData> {}
export class PendingStateUpdate extends BusinessObjectBase {
  static readonly entityName = 'PendingStateUpdate' as const;
  static readonly plural = 'pending-state-updates';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<PendingStateUpdate[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new PendingStateUpdate(data));
  }

  static async findOne(filter?: any): Promise<PendingStateUpdate | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new PendingStateUpdate(data) : null;
  }

  static async findById(id: string, filter?: any): Promise<PendingStateUpdate> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new PendingStateUpdate(data);
  }

  static async create(
    data: Omit<PendingStateUpdateData, 'id'>,
  ): Promise<PendingStateUpdate> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new PendingStateUpdate(result);
  }

  static async updateById(
    id: string,
    data: Partial<PendingStateUpdateData>,
  ): Promise<PendingStateUpdate> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new PendingStateUpdate(result);
  }

  static async deleteById(id: string): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
